import { Navigate } from 'react-router-dom';
import Home from './pages/Home';
import TestPage from './pages/TestPage';
import CategoryDetail from './pages/CategoryDetail';
import SearchResults from './pages/SearchResults';
import Profile from './pages/Profile';
import Admin from './pages/Admin';
import About from './pages/About';
import Submission from './pages/Submission';
import Disclaimer from './pages/Disclaimer';
import Contact from './pages/Contact';
import AICreator from './pages/AICreator';
import Resources from './pages/Resources';
import UnlockPage from './pages/UnlockPage';
import BrowserPage from './pages/BrowserPage';
import JuguangBrowser from './pages/JuguangBrowser';
import SearchPage from './pages/SearchPage';
import LoginPage from './pages/LoginPage';
import SupportPage from './pages/SupportPage';
import AIHubPage from './pages/AIHubPage';
import MembershipPage from './pages/MembershipPage';
import CommunityPage from './pages/CommunityPage';
import CopyPolishing from './pages/ai-tools/CopyPolishing';
import Transcription from './pages/ai-tools/Transcription';
import OrderDetailsPage from './pages/OrderDetailsPage';
import PostDetailPage from './pages/PostDetailPage';
import AdminDashboard from './pages/AdminDashboard';
import BadgeShop from './pages/BadgeShop';
import TaskCenter from './pages/TaskCenter';
import AchievementWall from './pages/AchievementWall';
import TemplateMarketplace from './pages/TemplateMarketplace';

export interface RouteConfig {
  path: string;
  element: React.ReactNode;
  children?: RouteConfig[];
}

export const routes: RouteConfig[] = [
  {
    path: '/test',
    element: <TestPage />,
  },
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/category/:id',
    element: <CategoryDetail />,
  },
  {
    path: '/search-results',
    element: <SearchResults />,
  },
  {
    path: '/profile',
    element: <Profile />,
  },
  {
    path: '/membership',
    element: <MembershipPage />,
  },
  {
    path: '/orders/:orderNo',
    element: <OrderDetailsPage />,
  },
  {
    path: '/ai-hub',
    element: <AIHubPage />,
  },
  {
    path: '/community',
    element: <CommunityPage />,
  },
  {
    path: '/community/post/:postId',
    element: <PostDetailPage />,
  },
  {
    path: '/ai-hub/copy-polishing',
    element: <CopyPolishing />,
  },
  {
    path: '/ai-hub/transcription',
    element: <Transcription />,
  },
  {
    path: '/admin',
    element: <AdminDashboard />,
  },
  {
    path: '/badge-shop',
    element: <BadgeShop />,
  },
  {
    path: '/tasks',
    element: <TaskCenter />,
  },
  {
    path: '/achievements',
    element: <AchievementWall />,
  },
  {
    path: '/template-market',
    element: <TemplateMarketplace />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/submission',
    element: <Submission />,
  },
  {
    path: '/disclaimer',
    element: <Disclaimer />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/ai-creator',
    element: <AICreator />,
  },
  {
    path: '/resources',
    element: <Resources />,
  },
  {
    path: '/unlock',
    element: <UnlockPage />,
  },
  {
    path: '/advanced',
    element: <UnlockPage />,
  },
  {
    path: '/browser',
    element: <BrowserPage />,
  },
  {
    path: '/juguang-browser',
    element: <JuguangBrowser />,
  },
  {
    path: '/search',
    element: <SearchPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/support',
    element: <SupportPage />,
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
];
